import { assign, startCase } from 'lodash-es';

import type { Type } from '@angular/core';

import type { Constructable, PrimitiveConstructable } from '@bp/shared/models/core';
import type { Enumeration } from '@bp/shared/models/core/enum';

import { FieldViewType } from './enums';
import { PropertyMetadataControl } from './property-metadata-control';
import type { PropertyMetadataTable } from './property-metadata-table';

export type PropertyMapperFunction = (propertyDTO: any, instanceDTO: any, thisInstance: any) => any;

export type PropertyMapper = PropertyMapperFunction
| Type<Constructable>
| Type<Enumeration>
| Type<PrimitiveConstructable>
| typeof Constructable
| typeof Enumeration
| typeof PrimitiveConstructable;

export class PropertyMetadata {

	readonly label?: string | null;

	/**
	 * On construction a value for the property is taken from DTO[alias]
	 * On deserialization the json will contain an alias property with a value equal the instance property value
	 */
	readonly alias?: string | null;

	readonly hint: string = '';

	readonly longHint: string = '';

	readonly mapper: PropertyMapper | null = null;

	readonly defaultPropertyValue?: unknown;

	readonly control = new PropertyMetadataControl();

	readonly viewType = FieldViewType.text;

	readonly viewFormatter: ((propertyValue: any) => any) | null = null;

	readonly viewEmptyValue: number | string | null = null;

	readonly table: PropertyMetadataTable | null = null;

	readonly unserializable: boolean = false;

	readonly sourceOfDTO: boolean = false;

	readonly copyable: boolean = false;

	readonly underDevelopment: boolean = false;

	readonly isSecret: boolean = false;

	readonly symbolize: string | null = null;

	/**
	 * The name of the property to which this metadata belongs
	 */
	readonly property!: string;

	readonly displayPropertyName: string;

	constructor(data: Partial<PropertyMetadata>) {
		assign(this, data);

		this.displayPropertyName = startCase(this.property);

		this.label = this.label !== undefined && this.label !== this.displayPropertyName
			? this.label
			: this.displayPropertyName;
	}

	toString(): string {
		return this.label!;
	}

	valueOf(): any {
		return this.property;
	}

}
